import React, { useState } from "react";
import { renderTagName } from "common/helpers/useTagsName";
import { useReports } from "hooks/useReports";
import "./reportBox.scss";

type RenderTagsProps = {
  reportTagsArray: number[];
};

export const RenderTagsWithOnHOverOption = ({
  reportTagsArray,
}: RenderTagsProps) => {
  const { tags } = useReports();
  const arratLengthTODisplay = 5;

  if (reportTagsArray.length <= arratLengthTODisplay) {
    return (
      <div>
        {reportTagsArray.map((dt: number) => (
          <div key={dt}>{renderTagName(dt, tags)}</div>
        ))}
      </div>
    );
  }

  const firstTags = reportTagsArray.slice(0, arratLengthTODisplay);
  const remainingTags = reportTagsArray.slice(arratLengthTODisplay);

  const remainingTagsCount = reportTagsArray.length - arratLengthTODisplay;

  return (
    <>
      {firstTags?.map((dt: number) => (
        <div className="text" key={dt}>
          {renderTagName(dt, tags) ?? dt}
        </div>
      ))}
      {remainingTagsCount > 0 && (
        <>
          <div className="circle">{remainingTagsCount}</div>
          <div className="floating-element">
            {remainingTags?.map((dt: number, index: number) => (
              <React.Fragment key={dt}>
                {renderTagName(dt, tags) ?? dt}
                {index !== remainingTags.length - 1 && ", "}
              </React.Fragment>
            ))}
          </div>
        </>
      )}
    </>
  );
};
